<div class="container">
  <div class="row">
  <div class="staticPages">

  <div data-language="bg"  *ngIf="selectedLang === 'bg'">

  <div class="agreements">
  За да използвате всички услуги на сайта, трябва да сте съгласни с Общите условията за ползване.
  </div>
  <h1>Общи условия при регистрация на посетители (на физическо лице)</h1>

  <p><br>
    <b class="bold">I. Всеки посетител на сайта трябва да се регистрира, за да:</b></p>
    <ul>
        <li>публикува коментар;</li>
      <li>гласува (оцени) дадено заведение (фирма);</li>
      <li>осъществява услугата “поръчка на храна за вкъщи”;</li>



      </ul>
    <p><b class="bold">II. Права и задължения на Zavedenia.bg</b></p>
    <ul>
      <li>Zavedenia.bg се задължава да спазва всички изисквания на Европейския регламент за защита на личните данни и прилежащите тълкования при Комисия за защита на личните данни.</li>
      <li>Zavedenia.bg не носи отговорност за съдържанието на публикуван коментар или гласуване за заведение, стига условията за които услуги да са спазени коректно.</li>
    </ul>

    <p><b class="bold">III. Права и задължения на посетителите на сайта Zavedenia.bg и сайтовете управлявани от Zavedenia.BG, като например системите за онлайн поръчки на ресторанти</b></p>
    <ul>
      <li>Посетителите са длъжни да публикуват коректна и пълна, за нуждите на предоставяната услуга, информация за себе си, да не публикуват нецензурни снимки и текстове, обидни думи и фрази.</li>
      <li>Публикуване на коментар: всеки има право да изрази мнение за дадено заведение. Забранява се публикуването на нецензурни снимки и текстове, обидни думи и фрази, злонамерени коментари. Zavedenia.bg не носи отговорност за съдържанието на коментара!</li>
      <li>Гласуване за заведение: всеки има право да хареса или не хареса дадено заведение и да изрази това с глас “ДА” или “НЕ”.  Zavedenia.bg има авоматична защита срещу злонамерено отрицателно гласуване, която се задейства при неколкократно гласуване с “НЕ” за даден обект от едно и също лице.</li>
      <li>Посетителите са съгласни с регистрацията си да предоставят определен набор лични данни, за нуждите на предлаганата от zavedenia.bg услуга, която искат да ползват. В това число: име, адрес, телефон, имейл за връзка; </li>
        <ul>
          <li>За нуждите на услугата “поръчка на храна” данните могат да бъдат предоставени на трети лица (заведенията, за които е направена поръчката). В това число: име, адрес, телефон, имейл за връзка; Това се случва само и единствено, когато посетителят направи поръчка на храна! Маркирането на полето е задължително!</li>
          <li>Регистриран посетител на сайта може винаги да изисква заличаване (изтриване)  на личните му данни или справка за всички налични данни, чрез писмена молбао към екипа на Zavedenia.bg. Редактиране и обновяване може да осъществява по всяко време</li>
          <li>Заявка за описаните предходни точки, може да бъде изпращана на email personaldata&#64;zavedenia.bg, като ние ще отговорим / изпълним конктретната заявка в срок от 48 часа.</li>

        </ul>


    </ul>
    <p><b class="bold">IV. Защита на лични данни</b></p>
    <ul>
      <li>Като притежател на чужди лични данни, Zavedenia.bg се задължава надлежно и отговорно да ги съхранява на недостъпни от трети лица носители на данни, да редактира, изтрива и добавя такива, пряко свързани с осъществяване на основната дейност на фирмата.</li>
      <li>Всички съпътстващи дейности по обработка на лични данни са съгласно Европейския регламент за защита на личните данни.</li>
      <li>Регистриращите се посетители се съгласяват публикуваните от тях лични данни да се съхраняват за неограничен период от време. Всеки има право да заличи (изтрие) предоставените данни с изрична писмена молба към екипа на Zavedenia.bg.</li>



    </ul>
      <p><b class="bold">V. Промяна на общите условия при регистрация на посетители</b></p>
    <ul>
      <li>Zavedenia.bg (zavedenia.com) запазва правото си да променя общите условия при регистрация на заведение (фирма) и в 7 дневен срок да обяви промените публично.</li>
      <li>Всички промени ще бъдат публикувани на тази страница и всеки регистриран потребител ще има достъп до тях.</li>
    </ul>

      </div>
  <div data-language="sr" *ngIf="selectedLang === 'sr'">

    <div class="agreements">
      Da biste koristili sve usluge sajta, morate se složiti sa Opštim uslovima korišćenja.
    </div>
    <h1>Opšti uslovi za registraciju posetilaca (fizičkih lica)</h1>

    <p><br>
      <b class="bold">I. Svaki posetilac sajta mora da se registruje kako bi:</b></p>
      <ul>
          <li>objavio komentar;</li>
          <li>glasao (ocenio) određeni objekat (firmu);</li>
          <li>koristio uslugu „porudžbina hrane za poneti“;</li>
      </ul>

    <p><b class="bold">II. Prava i obaveze booknow.rs</b></p>
    <ul>
      <li>booknow.rs se obavezuje da poštuje sve zahteve Evropske regulative o zaštiti ličnih podataka i tumačenja Komisije za zaštitu ličnih podataka.</li>
      <li>booknow.rs ne snosi odgovornost za sadržaj objavljenog komentara ili glasanja za objekat, sve dok su uslovi za te usluge ispravno poštovani.</li>
    </ul>

    <p><b class="bold">III. Prava i obaveze posetilaca sajta booknow.rs i sajtova pod upravom booknow.rs, kao što su sistemi za onlajn porudžbine restorana</b></p>
    <ul>
      <li>Posetioci su dužni da objave tačne i potpune informacije o sebi, potrebne za pružanje usluge, da ne objavljuju neprimerene slike i tekstove, uvredljive reči i izraze.</li>
      <li>Objavljivanje komentara: svako ima pravo da izrazi mišljenje o određenom objektu. Zabranjeno je objavljivanje neprimerenih slika i tekstova, uvredljivih reči i zlonamernih komentara. booknow.rs ne snosi odgovornost za sadržaj komentara!</li>
      <li>Glasanje za objekat: svako ima pravo da izrazi da li mu se objekat dopada ili ne putem glasa "DA" ili "NE". booknow.rs poseduje automatsku zaštitu od zlonamernog negativnog glasanja koja se aktivira prilikom višestrukog glasanja sa "NE" za isti objekat od strane istog korisnika.</li>
      <li>Posetioci se saglašavaju da, registracijom, dostave određeni skup ličnih podataka neophodnih za uslugu koju žele da koriste na booknow.rs. U to spadaju: ime, adresa, telefon, email za kontakt;</li>
      <ul>
        <li>Za potrebe usluge „porudžbina hrane“, podaci mogu biti prosleđeni trećim licima (objektima kod kojih je porudžbina izvršena). U to spadaju: ime, adresa, telefon, email za kontakt. To se dešava isključivo kada posetilac izvrši porudžbinu! Obeležavanje polja je obavezno!</li>
        <li>Registrovani korisnik sajta uvek može zatražiti brisanje svojih ličnih podataka ili uvid u sve dostupne podatke putem pismenog zahteva timu booknow.rs. Ažuriranje i izmena podataka mogu se vršiti u svakom trenutku.</li>
        <li>Zahtevi u vezi sa navedenim tačkama mogu se slati na email: personaldata&#64;booknow.rs. Odgovorićemo / izvršićemo konkretan zahtev u roku od 48 sati.</li>
      </ul>
    </ul>

    <p><b class="bold">IV. Zaštita ličnih podataka</b></p>
    <ul>
      <li>Kao čuvar tuđih ličnih podataka, booknow.rs se obavezuje da ih odgovorno i pažljivo čuva na nosiocima podataka nedostupnim trećim licima, kao i da ih uređuje, briše i dodaje u skladu sa osnovnim delatnostima firme.</li>
      <li>Sve aktivnosti u vezi sa obradom ličnih podataka vrše se u skladu sa Evropskim pravilnikom o zaštiti podataka.</li>
      <li>Registrovani korisnici se slažu da se njihovi podaci mogu čuvati neograničeno. Svako ima pravo da zatraži brisanje dostavljenih podataka putem pisanog zahteva timu booknow.rs.</li>
    </ul>

    <p><b class="bold">V. Izmena opštih uslova registracije posetilaca</b></p>
    <ul>
      <li>booknow.rs (zavedenia.com) zadržava pravo da menja opšte uslove registracije objekata (firmi) i da u roku od 7 dana javno objavi promene.</li>
      <li>Sve izmene biće objavljene na ovoj stranici i svaki registrovani korisnik će imati pristup tim informacijama.</li>
    </ul>

  </div>
  <div data-language="mk" *ngIf="selectedLang === 'mk'">

    <div class="agreements">
      За да ги користите сите услуги на веб-страницата, мора да се согласите со Општите услови за користење.
    </div>
    <h1>Општи услови за регистрација на посетители (физички лица)</h1>

    <p><br>
      <b class="bold">I. Секој посетител на страницата мора да се регистрира за да може да:</b></p>
      <ul>
          <li>објави коментар;</li>
          <li>гласа (оцени) одреден локал (фирма);</li>
          <li>користи услуга „нарачка на храна за носење“;</li>
      </ul>

    <p><b class="bold">II. Права и обврски на Booky.mk</b></p>
    <ul>
      <li>Booky.mk се обврзува да ги почитува сите барања од Европската регулатива за заштита на личните податоци и толкувањата на Комисијата за заштита на личните податоци.</li>
      <li>Booky.mk не сноси одговорност за содржината на објавен коментар или глас за локал, сè додека условите за тие услуги се коректно испочитувани.</li>
    </ul>

    <p><b class="bold">III. Права и обврски на посетителите на страницата Booky.mk и страниците управувани од Booky.mk, како на пример системите за онлајн нарачки на ресторани</b></p>
    <ul>
      <li>Посетителите се должни да објават точни и комплетни информации за себе, потребни за користење на услугите, и да не објавуваат нецензурни слики и текстови, навредливи зборови и фрази.</li>
      <li>Објавување на коментар: секој има право да изрази мислење за одреден локал. Забрането е објавување на нецензурни слики и текстови, навредливи зборови и фрази, злонамерни коментари. Booky.mk не сноси одговорност за содржината на коментарот!</li>
      <li>Гласање за локал: секој има право да го изрази своето мислење за даден локал со глас „ДА“ или „НЕ“. Booky.mk има автоматска заштита од злонамерно негативно гласање која се активира при повеќекратно „НЕ“ од исто лице за ист објект.</li>
      <li>Посетителите се согласуваат со регистрацијата да достават определен сет на лични податоци, потребни за услугата што сакаат да ја користат преку Booky.mk. Тоа вклучува: име, адреса, телефон, е-пошта за контакт;</li>
      <ul>
        <li>За потребите на услугата „нарачка на храна“, податоците може да бидат доставени до трети лица (локалите за кои е направена нарачката). Тоа вклучува: име, адреса, телефон, е-пошта за контакт. Ова се случува исклучиво кога посетителот ќе направи нарачка! Означувањето на ова поле е задолжително!</li>
        <li>Регистриран посетител може во секое време да побара бришење на неговите лични податоци или увид во сите достапни податоци преку писмено барање до тимот на Booky.mk. Ажурирање и уредување на податоците е секогаш дозволено.</li>
        <li>Барања според горенаведените точки можат да се испраќаат на е-пошта: personaldata&#64;Booky.mk, а ние ќе одговориме / извршиме конкретното барање во рок од 48 часа.</li>
      </ul>
    </ul>

    <p><b class="bold">IV. Заштита на личните податоци</b></p>
    <ul>
      <li>Како чувар на туѓи лични податоци, Booky.mk е должен да ги чува одговорно и безбедно, на медиуми недостапни за трети лица, и да ги уредува, брише или додава, во согласност со главната дејност на компанијата.</li>
      <li>Сите активности поврзани со обработка на лични податоци се во согласност со Европската регулатива за заштита на личните податоци.</li>
      <li>Регистрираните посетители се согласуваат нивните објавени лични податоци да се чуваат на неопределено време. Секој има право да побара бришење на тие податоци со изрично писмено барање до тимот на Booky.mk.</li>
    </ul>

    <p><b class="bold">V. Измени на општите услови за регистрација на посетители</b></p>
    <ul>
      <li>Booky.mk (zavedenia.com) го задржува правото да ги менува општите услови за регистрација на локали (фирми) и во рок од 7 дена јавно да ги објави промените.</li>
      <li>Сите промени ќе бидат објавени на оваа страница и секој регистриран корисник ќе има пристап до нив.</li>
    </ul>

  </div>



  </div>
  </div>
  </div>
